import { render, staticRenderFns } from "./CustomersDropdown.vue?vue&type=template&id=3707fbbe&scoped=true"
import script from "./CustomersDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomersDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707fbbe",
  null
  
)

export default component.exports